export default "__VITE_ASSET__lsFnDscH__"